import { SearchIndexCourseFilters } from '@shared/types';

export const parseLevelFilter = (string: string): SearchIndexCourseFilters['level'] => {
    if (!string) {
        return undefined;
    }

    // Convert to proper case for matching:
    const normalizedString = string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();

    if (normalizedString === 'All') {
        return 'All';
    }
    if (normalizedString === 'Beginner') {
        return 'Beginner';
    }
    if (normalizedString === 'Intermediate') {
        return 'Intermediate';
    }
    if (normalizedString === 'Advanced') {
        return 'Advanced';
    }

    return undefined;
};
